import { Typography } from "@circle-react-uikit/Typography";
import type { FlaggedContent } from "@circle-react/types";

import { useVisibilityDescription } from "@/react/components/ModerationInfo/ModerationInfoModal/useVisibilityDescription";

interface VisibilityInfoProps {
  content?: FlaggedContent;
}

export const VisibilityInfo = ({ content }: VisibilityInfoProps) => {
  const visibilityMessage = useVisibilityDescription(content);

  if (!visibilityMessage) {
    return null;
  }

  return (
    <div className="flex items-center gap-4 px-8 py-0">
      <Typography.LabelSm>{visibilityMessage}</Typography.LabelSm>
    </div>
  );
};
